// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__1Wf7Y","closeButton":"styles_closeButton__2GDHK","title":"styles_title__2TXwk","content":"styles_content__BPQFI","actions":"styles_actions__3PVP3"};